const getPercentage = (value: number, min = 0, max = 100): number => {
    if (value > max) {
        return 100;
    }
    return ((value - min) * 100) / (max - min);
};

export default getPercentage;
